<div class="chart">
  <ngx-charts-area-chart [legendTitle]="legendTitle" [scheme]="colorScheme" [results]="multi" [gradient]="gradient"
    [xAxis]="showXAxis" [yAxis]="showYAxis" [legend]="showLegend" [legendPosition]="legendPosition" [curve]="curve"
    [timeline]="timeline" [showGridLines]="showGridLines" (select)="onSelect($event)" [view]="view">
  </ngx-charts-area-chart>
</div>